const s = "_dialog_1qsdm_1", o = "_box_1qsdm_1", _ = "_backdrop_1qsdm_1", d = "_drawer_1qsdm_51", c = "_sm_1qsdm_79", a = "_lg_1qsdm_82", l = "_close_1qsdm_86", t = {
  dialog: s,
  box: o,
  backdrop: _,
  drawer: d,
  sm: c,
  lg: a,
  close: l
};
export {
  _ as backdrop,
  o as box,
  l as close,
  t as default,
  s as dialog,
  d as drawer,
  a as lg,
  c as sm
};
//# sourceMappingURL=modal.module.less.js.map
